import gql from 'graphql-tag';

export const all = gql`query getFiles($fogId: ID!) {
    files(fogId: $fogId){
        id
        fog_id
        path
        mimetype
        name
        size
        deleted
    }
}`;


export const get = gql`query getFiles($id: ID!) {
    files(id: $id){
        id
        fog_id
        path
        mimetype
        name
        size
        deleted
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/queries/files.js